import script from "./ContentLocation.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentLocation.vue?vue&type=script&lang=ts&setup=true"

import "./ContentLocation.vue?vue&type=style&index=0&id=54f31e40&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54f31e40"]])

export default __exports__